import type { TableCommandFactory } from 'components/Table/model/TableModel';
import { TABLE_COLUMN_MIN_WIDTH } from 'components/Table/tableSettings';
import { getFilteredColumnMinWidth } from './helpers/getFilteredColumnMinWidth';

interface SetTableColumnWidthCommand {
  columnKey: string;
  width: number;
}

export const setTableColumnWidth: TableCommandFactory<
  SetTableColumnWidthCommand
> = (cmdContext) => async (command) => {
  const filter = cmdContext.getState().simpleFilterFields?.[command.columnKey];
  const appliedFilter = !!filter?.value;

  const minWidth = appliedFilter
    ? getFilteredColumnMinWidth(filter?.filter)
    : TABLE_COLUMN_MIN_WIDTH;

  const newWidth = Math.max(minWidth, command.width);

  cmdContext.updateState((draft) => {
    draft.settings.columnWidth = draft.settings.columnWidth ?? {};
    draft.settings.columnWidth[command.columnKey] = newWidth;
  });
};
